// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.send-file__title[data-v-6fe22542] {
  margin: 0;
}
.send-file__info[data-v-6fe22542] {
  margin: 0 0 0.5rem 0;
  word-break: break-all;
}
.nc-btn[data-v-6fe22542] {
  min-width: 96px;
}
.send-file__content[data-v-6fe22542] {
  margin-top: 1rem;
}
.send-file__content__table[data-v-6fe22542] {
  width: 100%;
  margin-top: 1em;
}
.send-file__content__table td[data-v-6fe22542] {
  padding: 0.2rem;
}
.send-file__content__container[data-v-6fe22542] {
  width: 80%;
  margin-right: auto;
  margin-left: auto;
  max-height: 400px;
  overflow-y: scroll auto;
}
button.success[data-v-6fe22542] {
  background-color: var(--color-success);
  border-color: var(--color-success-hover);
  color: var(--color-primary-text);
}
button.success[data-v-6fe22542]:hover {
  background-color: var(--color-success-hover);
}
.bbb-send-file-dialog[data-v-6fe22542] {
  min-width: 400px;
}
.send-file__content .note[data-v-6fe22542] {
  margin-top: 0.5rem;
  font-size: 0.9rem;
  color: var(--color-secondary-text);
  font-style: italic;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
